import type { FreeTrialFields } from '@/data/freetrial/model';
import Monolith from '@/shared/api/monolith';
import { parseAPIError } from '@/shared/redux/helpers/parseApiError';
import { createWiwAsyncThunk } from '@/store';

export const fetchFreeTrialStatus = createWiwAsyncThunk<FreeTrialFields>(
  'freeTrial/fetch',
  async (_, { rejectWithValue }) => {
    try {
      return await Monolith.get('/subscriptions/freetrial');
    } catch (error) {
      return rejectWithValue(parseAPIError(error));
    }
  },
);
